import type { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface DocumentTypeSettingsCardProps {
  children: ReactNode
}

export const DocumentTypeSettingsCard = ({ children }: DocumentTypeSettingsCardProps): ReactElement => (
  <Styled.CardWrapper>{children}</Styled.CardWrapper>
)
